import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import State from 'types/State';
import firebase from 'firebase/app';
import config from 'lib/config';

export default function useGoogleOneTap(): void {
  const isSignedIn = useSelector((state: State) => state.session.isSignedIn);

  useEffect(() => {
    if (!isSignedIn && typeof google !== 'undefined' && typeof window !== 'undefined') {
      (google as any).accounts.id.initialize({
        client_id: config.googleOAuthClientId,
        callback: (response: { credential: string }) => {
          firebase
            .auth()
            .signInWithCredential(firebase.auth.GoogleAuthProvider.credential(response.credential));
        },
        auto_select: true,
        context: 'use',
      });
      (google as any).accounts.id.prompt();
    }
  }, [isSignedIn]);
}
